import { NavLink } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { getBottomTabsForRole } from '@/lib/permissions';
import { MoreHorizontal } from 'lucide-react';

export default function BottomTabs({ onMoreClick }) {
  const { user, userPermissions } = useAuth();
  const tabs = getBottomTabsForRole(user?.role, userPermissions);

  return (
    <nav
      data-print="rahmen"
      className="fixed bottom-0 left-0 right-0 z-30 md:hidden border-t border-border bg-background/95 backdrop-blur-md"
      data-testid="bottom-tabs"
    >
      <div className="flex items-center justify-around h-14 px-1">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <NavLink
              key={tab.path}
              to={tab.path}
              end={tab.path === '/'}
              data-testid={`btab-${tab.label.toLowerCase().replace(/\s+/g, '-')}`}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 flex-1 py-1 transition-colors ${
                  isActive ? 'text-primary' : 'text-muted-foreground'
                }`
              }
            >
              <Icon className="w-5 h-5" />
              <span className="text-[10px] font-medium">{tab.label}</span>
            </NavLink>
          );
        })}
        {/* More button */}
        <button
          onClick={onMoreClick}
          className="flex flex-col items-center justify-center gap-0.5 flex-1 py-1 text-muted-foreground"
          data-testid="btab-more"
        >
          <MoreHorizontal className="w-5 h-5" />
          <span className="text-[10px] font-medium">More</span>
        </button>
      </div>
      {/* Safe area for iPhones with home indicator */}
      <div className="h-[env(safe-area-inset-bottom)]" />
    </nav>
  );
}
